import type { ReqConfig } from './model'

export type ApiGETFn = <TResponse, TBody = unknown>(
  url: string,
  reqConfig?: Partial<ReqConfig>,
) => (body?: TBody | undefined) => Promise<TResponse>

// This object is populated by the useApi hook once it's mounted
// Services can import this directly without circular dependency issues
export const standaloneApi: {
  get: ApiGETFn | null
  post: ApiGETFn | null
  patch: ApiGETFn | null
  put: ApiGETFn | null
} = {
  get: null,
  post: null,
  patch: null,
  put: null,
} as const
